"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserLogoutExecuteEvent = exports.Name = void 0;
const Name = exports.Name = 'user-logout-execute';
const UserLogoutExecuteEvent = exports.UserLogoutExecuteEvent = Name;
